import { Message } from 'element-ui'
import { getWebPage, getWebDetailConfig } from '@/api/common'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    homeList: [],
  },
  mutations: {
    setLoading(state, isLoading) {
      state.isLoading = isLoading
    },
    setHomeList(state, homeList) {
      state.homeList = homeList
    }
   
  },
  actions: {
    // 页面加载中
    onLoading(context, isLoading) {
      context.commit('setLoading', isLoading)
    },
    // 获取官网页面配置
    getWebPage(context, pageName) {
      getWebPage(pageName).then(res => {
        if (res.code === 0) {
          context.commit('setHomeList', res.data.list)
        }
      })
    },
    // 获取官网页面详情配置
    getWebDetailConfig(context, id) {
      return new Promise(async (resolve, reject) => {
        const res = await getWebDetailConfig({ id })
        if (res.code === 0) {
          resolve(res.data)
        } else {
          Message.error(res.error)
        }
      })
    }

  },
  getters: {}
}
